var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader.js";
import { MTLLoader } from "./MTLLoader";
export class CustomOBJLoader extends OBJLoader {
    constructor() {
        super(...arguments);
        this.mtlLoader = new MTLLoader();
    }
    loadMtlAndObjPromise(urlWithoutEnding) {
        return __awaiter(this, void 0, void 0, function* () {
            const materials = yield this.loadMtlPromise(`${urlWithoutEnding}.mtl`);
            materials.preload();
            this.setMaterials(materials);
            return yield this.loadObjPromise(`${urlWithoutEnding}.obj`);
        });
    }
    loadMtlPromise(url) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                this.mtlLoader.load(url, (materialCreator) => {
                    resolve(materialCreator);
                }, () => { }, () => {
                    reject(new Error(`[renderer] Could not load ${url}`));
                });
            });
        });
    }
    loadObjPromise(url) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                this.load(url, (group) => {
                    group.traverse((child) => {
                        child.matrixAutoUpdate = false;
                        child.updateMatrix();
                    });
                    resolve(group);
                }, () => { }, () => {
                    reject(new Error(`[renderer] Could not load ${url}`));
                });
            });
        });
    }
}
